/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { internals, setDefaultAria } from '../../../constants';
import { setDefaultAria as setDefaultAriaUtil } from '../../utils/a11y-utils';
/**
 * Mixes in Element Internals functionality into a base component.
 *
 * @param base The base component to mix into.
 * @returns The mixed-in base component.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function WithDefaultAria(base) {
    class DefaultAria extends base {
        [setDefaultAria](properties, options) {
            setDefaultAriaUtil(this, this[internals], properties, options);
        }
    }
    return DefaultAria;
}
